import "../App.css";
import HireMe from "./HireMe";

// import splash from "../assets/images/Sunday_Splash.png";

export default function Home() {
  // const currentYear = new Date().getFullYear();
  return (
    <div
      className="tab-pane show fade active home"
      id="home-tab-pane"
      role="tabpanel"
      aria-labelledby="home-tab"
      tabIndex="0"
    >
      <div className="row">
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item" aria-current="page">
              <small>
                <code>$ ~/portfolio/src/components/Home.js</code>
              </small>
            </li>
          </ol>
        </nav>
      </div>
      <div className="container-fluid py-5">
        <div className="row">
          <div className="col-12 col-md-6 d-flex justify-content-center align-items-center">
            <div className="hero-info">
              <h1 className="display-5 fw-bold text-center m-0">
                <span className="en-intro">My name is Sunday Oruwhone</span>
                <span className="de-intro">Ich heiße Sunday Oruwhone</span>
              </h1>
              <p className="text-center fs-4">
                I am a Software Engineer and Tutor focused on Frontend Web
                Developement.
              </p>
              <p className="text-center fs-4">
                I'm a Creative Frontend Web Developer based In Lagos, Nigeria.
              </p>
              <p className="text-center fs-4">
                Let us get started on your next idea.
              </p>
              <div className="d-grid gap-2 d-sm-flex justify-content-sm-center">
                <button
                  type="button"
                  className="btn btn-primary btn-lg px-4 gap-3"
                  data-bs-toggle="modal"
                  data-bs-target="#hireMe"
                >
                  Hire Me
                </button>
                <a
                  // download={"Sunday Oruwhone CV (" + currentYear + ").pdf"}
                  // href="https://docs.google.com/document/d/1ocDekhxp9KxNqNtb6MkeAlDd9gDQ14vbsIGvzyYVK4I/edit"
                  target="_blank"
                  rel="noreferrer"
                  className="btn btn-outline-secondary btn-lg px-4"
                  href="https://docs.google.com/document/d/1Paw41lCuey5gV3G638kgISpKtQe7Fspj/edit?usp=sharing&ouid=103642273281584144420&rtpof=true&sd=true"
                >
                  View CV
                </a>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-6 d-flex justify-content-center align-items-center d-none d-md-flex">
            {/* <img src={splash} alt="Sunday" className="img-fluid" /> */}
            <iframe
              width="560"
              height="315"
              src="https://www.youtube.com/embed/vHBHJgZ9Ie0?si=74EUtWYC7r-WjXYY"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerpolicy="strict-origin-when-cross-origin"
              allowfullscreen
            ></iframe>
          </div>
        </div>
      </div>
      <HireMe />
    </div>
  );
}
